import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';
// from,    12.48%,   24.96%,   37.44%,   49.92%,   62.4%,    74.88%,   87.36%,  to  { transform: none; }
// 2.08%,   14.56%,   27.04%,   39.52%,   52%,      64.48%,   76.96%,   89.44%       { transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -5deg); }
// 4.16%,   16.64%,   29.12%,   41.6%,    54.08%,   66.56%,   79.04%,   91.52%       { transform: translate3d(4%, 0, 0)  rotate3d(0, 0, 1, 3deg);  }
// 6.24%,   18.72%,   31.2%,    43.68%,   56.16%,   68.64%,   81.12%,   93.6%        { transform: translate3d(-3%, 0, 0) rotate3d(0, 0, 1, -3deg); }
// 8.32%,   20.8%,    33.28%,   45.76%,   58.24%,   70.72%,   83.2%,    95.68%       { transform: translate3d(2%, 0, 0)  rotate3d(0, 0, 1, 2deg);  }
// 10.4%,   22.88%,   35.36%,   47.84%,   60.32%,   72.8%,    85.28%,   97.76%       { transform: translate3d(-1%, 0, 0) rotate3d(0, 0, 1, -1deg); }


const shakePhone = keyframes `
  from { transform: none; }
  15%  { transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -5deg); }
  30%  { transform: translate3d(4%, 0, 0)  rotate3d(0, 0, 1, 3deg);  }
  45%  { transform: translate3d(-3%, 0, 0) rotate3d(0, 0, 1, -3deg); }
  60%  { transform: translate3d(2%, 0, 0)  rotate3d(0, 0, 1, 2deg);  }
  75%  { transform: translate3d(-1%, 0, 0) rotate3d(0, 0, 1, -1deg); }
  to   { transform: none; }
`;

const phoneRipple = keyframes `
  from, 45% {
    box-shadow: 0 0 0 0 rgba(122, 148, 252, 0),
                0 0 0 0 rgba(122, 148, 252, 0);
    transform: scale(0);
    opacity: 0;
  }

  from, 50.5%, 63% {
    box-shadow: 0 0 0 0 rgba(122, 148, 252, 0),
                0 0 0 0 rgba(122, 148, 252, 0);
    transform: scale(1);
    opacity: 1;
  }
  56.25%, 68.75% {
    box-shadow: 0 0 0 0 rgba(122, 148, 252, 0.2),
                0 0 0 1rem rgba(122, 148, 252, 0.1);
    transform: scale(1.1);
    opacity: 1;
  }
  50%, 62.5% {
    box-shadow: 0 0 0 1rem rgba(122, 148, 252, 0),
                0 0 0 1.5rem rgba(122, 148, 252, 0);
    transform: scale(1);
    opacity: 1;
  }
  75%, to {
    box-shadow: 0 0 0 1rem rgba(122, 148, 252, 0),
                0 0 0 1.5rem rgba(122, 148, 252, 0);
    transform: scale(0);
    opacity: 0;
  }
`;

const scrollMobileAfterFooter = keyframes `
  from, 40%, 80%, to { transform: translate(0,0) }
  45%, 75% { transform: translate(0,80px) }

  from, 40%, 55%, to { opacity: 1; }
  45%, 50% { opacity: 0; }
`;

const callToolsText = keyframes `
  53%, 70% { opacity: 1; }
  from, 48%, 75%, to { opacity: 0; }
`;

const scrollMobileAfterPageHeader = keyframes `
  from, 65%, to { transform: translate(0,0) }
  5%, 40% { transform: translate(0,-73px) }
  45%, 60% { transform: translate(0,-200px) }

  from, 40%, 80%, to { opacity: 1; }
  45%, 75% { opacity: 0; }
`;

const scrollMobileAfterPanel = keyframes `
  from, 65%, to { transform: translate(0,0) }
  20%, 60% { transform: translate(0,-365px)  }

  from, 40%, 80%, to { opacity: 1; }
  45%, 75% { opacity: 0; }
`;

const scrollMobileAfterCheckbox = keyframes `
  from { transform: translate(0,0) }
  20%, to { transform: translate(0,-365px)  }

  from, 25%, 45%, to { opacity: 0; }
  30%, 40% { opacity: 1;  }
`;

const scrollMobileAfterCantReach = keyframes `
  from, 25% { opacity: 0; }
  30%, to { opacity: 1;  }
  from, 40% { transform: translate(0,0) }
  45%, to { transform: translate(0,80px) }
`;

const CallToolsMobileCursor = keyframes `
  from, 20% { transform: translate(-48px, 480px); }
  25%, 30% { transform: translate(27px, 350px); }
  40%, to{ transform: translate(280px, 620px); }

  from, 40% { opacity: 1; }
  45%, to { opacity: 0; }
`;

const MobileFullSizeContainer = styled.div`
  position: relative;
  text-align: center;
  overflow: hidden;
  max-width: 360px;
  box-shadow: 0 15px 35px rgba(50,50,93,.1), 0 0px 15px rgba(0,0,0,.1);
  margin: 0 auto;
  img {
    position: absolute;
    top: 0;
    max-width: 360px;
    border-radius: 8px;
    box-shadow: none;
  }
  svg {
    background: #EFF2F5;
    vertical-align: top;
   }
   #callTool-cursor { animation: ${CallToolsMobileCursor} 8s infinite; }
   #callTool-panel { animation: ${scrollMobileAfterPanel} 8s infinite; }
   #callTool-checkbox-container { animation: ${scrollMobileAfterCheckbox} 8s infinite; }
   #callTool-checkbox { animation: ${scrollMobileAfterCheckbox} 8s infinite; }
   #callTool-page-header { animation: ${scrollMobileAfterPageHeader} 8s infinite; }
   #callTool-cant-reach, #callTool-save-next { animation: ${scrollMobileAfterCantReach} 8s infinite; }
   #callTool-footer { animation: ${scrollMobileAfterFooter} 8s infinite; }
   #callTool-loading {
     position: absolute;
     top: calc((152/360) * 100%);
     right: calc((296/680) * 100%);
     width: calc((56/360) * 100%);
     animation: ${phoneRipple} 8s infinite;
     border-radius: 100%;
   }
   #callTool-phone { animation: ${shakePhone} 1.25s infinite; }
   #callTool-text  { animation: ${callToolsText} 8s infinite; }
`;

class CallToolsMobile extends Component {
  constructor() {
    super();
    this.state = {
      callToolsBefore: false,
      callToolsAfter: true
    }
  }
  showCallToolsBefore(e){
    e.preventDefault();
    this.setState({callToolsBefore: true});
    this.setState({callToolsAfter: false})
  }

  showCallToolsAfter(e){
    e.preventDefault();
    this.setState({callToolsBefore: false});
    this.setState({callToolsAfter: true})
  }

  render() {
    return (
        <MobileFullSizeContainer>
            <svg id="callTool-loading" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56">
              <defs>
              <linearGradient id="a" x1="100%" x2="0%" y1="0%" y2="100%">
                <stop stopColor="#91A7FF" offset="0%"/>
                <stop stopColor="#5C7CFA" offset="100%"/>
              </linearGradient>
              <filter id="b" width="131.2%" height="132.7%" x="-15.6%" y="-8.2%" filterUnits="objectBoundingBox">
                <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/>
                <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
                <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" in="shadowBlurOuter1"/>
              </filter>
              </defs>
              <g fill="none" fillRule="evenodd">
                <rect width="56" height="56" fill="url(#a)" rx="28"/>
                <g id="callTool-phone" fillRule="nonzero">
                  <path fill="#000" filter="url(#b)" d="M40.42 34.566l-1.52-.712s-2.206-.997-3.586-1.71c-.138 0-.276-.142-.414-.142-.414 0-.69.142-.966.285 0 0-.138.142-2.07 2.42-.138.286-.414.43-.69.43h-.138c-.138 0-.414-.144-.552-.286l-.69-.282c-1.518-.712-2.898-1.567-4.002-2.707-.276-.284-.69-.57-.966-.854-.966-.997-1.932-2.137-2.622-3.42l-.138-.284c-.138-.14-.138-.283-.276-.567 0-.285 0-.57.138-.713 0 0 .552-.713.966-1.14.276-.285.414-.712.69-.997.276-.428.414-.997.276-1.425-.138-.712-1.794-4.558-2.208-5.412-.276-.428-.552-.57-.966-.713h-1.518c-.276 0-.552.143-.827.143l-.135.142c-.276.143-.552.428-.828.57-.276.285-.414.57-.69.855-.966 1.282-1.518 2.848-1.518 4.415 0 1.14.275 2.28.69 3.276l.137.428c1.242 2.706 2.897 5.128 5.105 7.264l.553.57c.414.427.828.712 1.104 1.14 2.897 2.564 6.21 4.415 9.935 5.412.414.143.966.143 1.38.285h1.38c.69 0 1.518-.285 2.07-.57.413-.284.69-.284.965-.57l.276-.284c.276-.286.552-.43.828-.713.277-.285.553-.57.69-.855.277-.57.415-1.28.553-1.993v-.998s-.138-.142-.414-.284z"/>
                  <path fill="#FFF" fillRule="evenodd" d="M40.42 34.566l-1.52-.712s-2.206-.997-3.586-1.71c-.138 0-.276-.142-.414-.142-.414 0-.69.142-.966.285 0 0-.138.142-2.07 2.42-.138.286-.414.43-.69.43h-.138c-.138 0-.414-.144-.552-.286l-.69-.282c-1.518-.712-2.898-1.567-4.002-2.707-.276-.284-.69-.57-.966-.854-.966-.997-1.932-2.137-2.622-3.42l-.138-.284c-.138-.14-.138-.283-.276-.567 0-.285 0-.57.138-.713 0 0 .552-.713.966-1.14.276-.285.414-.712.69-.997.276-.428.414-.997.276-1.425-.138-.712-1.794-4.558-2.208-5.412-.276-.428-.552-.57-.966-.713h-1.518c-.276 0-.552.143-.827.143l-.135.142c-.276.143-.552.428-.828.57-.276.285-.414.57-.69.855-.966 1.282-1.518 2.848-1.518 4.415 0 1.14.275 2.28.69 3.276l.137.428c1.242 2.706 2.897 5.128 5.105 7.264l.553.57c.414.427.828.712 1.104 1.14 2.897 2.564 6.21 4.415 9.935 5.412.414.143.966.143 1.38.285h1.38c.69 0 1.518-.285 2.07-.57.413-.284.69-.284.965-.57l.276-.284c.276-.286.552-.43.828-.713.277-.285.553-.57.69-.855.277-.57.415-1.28.553-1.993v-.998s-.138-.142-.414-.284z"/>
                </g>
              </g>
            </svg>
            <img alt="" id="callTool-panel" src={require('../../../assets/CallTools/Mobile/panel.svg')} />
            <img alt="" id="callTool-checkbox" src={require('../../../assets/CallTools/Mobile/checkbox.svg')} />
            <img alt="" id="callTool-page-header" src={require('../../../assets/CallTools/Mobile/pageheader.svg')} />
            <img alt="" src={require('../../../assets/CallTools/Mobile/header.svg')} />
            <img alt="" id="callTool-footer" src={require('../../../assets/CallTools/Mobile/footer.svg')} />
            <img alt="" id="callTool-cant-reach" src={require('../../../assets/CallTools/Mobile/cantreach.svg')} />
            <img alt="" id="callTool-save-next" src={require('../../../assets/CallTools/Mobile/savenext.svg')} />
            <img alt="" id="callTool-cursor" src={require('../../../assets/CallTools/Mobile/cursor.svg')} />
            <svg id="callTool-background" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 680">
              <path id="callTool-text" fill="#212529" fillRule="evenodd" d="M90.762 385.266c2.398 0 4.18-1.336 4.554-3.407h-1.43c-.36 1.304-1.554 2.11-3.124 2.11-2.172 0-3.532-1.775-3.532-4.603s1.36-4.61 3.524-4.61c1.555 0 2.758.915 3.133 2.368h1.43c-.337-2.172-2.188-3.664-4.563-3.664-3.063 0-4.97 2.267-4.97 5.907 0 3.633 1.915 5.9 4.978 5.9zm10.203-1.33c1.594.002 2.492-1.155 2.492-3.147 0-2-.898-3.15-2.492-3.15-1.594 0-2.492 1.15-2.492 3.15 0 1.99.898 3.147 2.492 3.147zm0 1.212c-2.4 0-3.883-1.656-3.883-4.36 0-2.71 1.484-4.358 3.883-4.358 2.398 0 3.883 1.648 3.883 4.36 0 2.702-1.485 4.358-3.883 4.358zm5.992-.148h1.344v-4.984c0-1.477.868-2.375 2.212-2.375 1.343 0 1.984.72 1.984 2.235V385h1.344v-5.453c0-2-1.055-3.117-2.945-3.117-1.29 0-2.11.547-2.532 1.476h-.125v-1.328h-1.28V385zm9.336 0h1.344v-4.984c0-1.477.867-2.375 2.21-2.375 1.344 0 1.985.72 1.985 2.235V385h1.344v-5.453c0-2-1.055-3.117-2.946-3.117-1.29 0-2.11.547-2.53 1.476h-.126v-1.328h-1.28V385zm12.695-7.383c-1.343 0-2.28.985-2.383 2.477h4.64c-.03-1.492-.92-2.477-2.257-2.477zm2.22 5.203h1.343c-.405 1.446-1.702 2.328-3.546 2.328-2.336 0-3.797-1.687-3.797-4.35 0-2.65 1.484-4.368 3.797-4.368 2.273 0 3.656 1.617 3.656 4.234v.516h-6.055v.062c.07 1.664 1 2.72 2.43 2.72 1.086 0 1.82-.4 2.172-1.142zm10.53-3.664c-.234-1.5-1.484-2.726-3.53-2.726-2.36 0-3.86 1.703-3.86 4.328 0 2.68 1.507 4.39 3.867 4.39 2.023 0 3.28-1.14 3.523-2.687h-1.36c-.25.954-1.038 1.478-2.17 1.478-1.5 0-2.47-1.235-2.47-3.18 0-1.906.953-3.117 2.47-3.117 1.21 0 1.952.68 2.17 1.516h1.36zm2.703-4.758v2.18h-1.358v1.125h1.36v5.11c0 1.61.695 2.25 2.43 2.25.265 0 .523-.032.788-.08v-1.13c-.25.022-.383.03-.625.03-.875 0-1.25-.422-1.25-1.414v-4.767h1.875v-1.125h-1.875v-2.18h-1.344zM149.724 385h1.343v-8.422h-1.343V385zm.672-10.133c.515 0 .937-.422.937-.937 0-.516-.422-.938-.937-.938-.516 0-.938.422-.938.938 0 .515.422.937.938.937zM153.63 385h1.343v-4.984c0-1.477.867-2.375 2.21-2.375 1.344 0 1.985.72 1.985 2.235V385h1.344v-5.453c0-2-1.055-3.117-2.946-3.117-1.29 0-2.11.547-2.53 1.476h-.126v-1.328h-1.28V385zm15.24-4.336c0-1.836-.944-3.023-2.5-3.023-1.56 0-2.436 1.188-2.436 3.024s.875 3.024 2.437 3.024c1.564 0 2.5-1.188 2.5-3.024zm-2.436 7.57c-2.032 0-3.33-.914-3.532-2.304h1.422c.15.687.9 1.132 2.11 1.132 1.507 0 2.406-.742 2.406-1.984v-1.656h-.125c-.53.93-1.485 1.453-2.64 1.453-2.18 0-3.532-1.688-3.532-4.21 0-2.524 1.367-4.235 3.53-4.235 1.18 0 2.22.578 2.704 1.484h.125v-1.336h1.282v8.57c0 1.883-1.454 3.086-3.75 3.086zm11.36-13.836v2.18h-1.36v1.125h1.36v5.11c0 1.61.694 2.25 2.43 2.25.264 0 .522-.032.788-.08v-1.13c-.25.022-.383.03-.625.03-.875 0-1.25-.422-1.25-1.414v-4.767h1.875v-1.125h-1.875v-2.18h-1.344zm8.593 9.54c1.593 0 2.492-1.157 2.492-3.15 0-2-.9-3.147-2.493-3.147-1.594 0-2.492 1.15-2.492 3.15 0 1.99.898 3.147 2.492 3.147zm0 1.21c-2.4 0-3.883-1.656-3.883-4.36 0-2.71 1.484-4.358 3.883-4.358 2.398 0 3.883 1.648 3.883 4.36 0 2.702-1.485 4.358-3.883 4.358zm13.1-1.18c1.384 0 2.408-.906 2.408-2.11v-.772l-2.266.148c-1.282.086-1.845.532-1.845 1.375 0 .86.727 1.36 1.703 1.36zm-.25 1.18c-1.632 0-2.842-.968-2.842-2.507 0-1.507 1.11-2.374 3.07-2.492l2.43-.148v-.766c0-1.04-.65-1.61-1.907-1.61-1.008 0-1.71.384-1.898 1.048h-1.36c.18-1.352 1.508-2.242 3.305-2.242 2.055 0 3.203 1.054 3.203 2.804V385h-1.28v-1.242h-.126c-.547.898-1.47 1.39-2.594 1.39zm15.103-8.718c2.148 0 3.54 1.71 3.54 4.36 0 2.632-1.4 4.358-3.54 4.358-1.203 0-2.172-.523-2.633-1.414h-.125v4.08l-1.344-.002V376.58h1.282v1.406h.125c.54-.968 1.546-1.554 2.695-1.554zm-.32 7.507c1.546 0 2.468-1.18 2.468-3.148 0-1.97-.922-3.15-2.46-3.15-1.524 0-2.485 1.212-2.485 3.15 0 1.93.96 3.147 2.477 3.147zm9.328-6.32c-1.344 0-2.282.985-2.383 2.477h4.64c-.03-1.492-.92-2.477-2.257-2.477zm2.218 5.203h1.344c-.406 1.446-1.703 2.328-3.547 2.328-2.336 0-3.797-1.687-3.797-4.35 0-2.65 1.485-4.368 3.797-4.368 2.274 0 3.657 1.617 3.657 4.234v.516h-6.055v.062c.07 1.664 1 2.72 2.43 2.72 1.085 0 1.82-.4 2.17-1.142zm3.563 2.18h1.343v-5.22c0-1.186.93-2.046 2.21-2.046.266 0 .75.047.86.08v-1.345c-.172-.025-.453-.04-.672-.04-1.116 0-2.085.578-2.335 1.398h-.125v-1.25h-1.28V385zm5.74-6.117c0 1.22.72 1.898 2.298 2.28l1.445.353c.9.218 1.336.61 1.336 1.187 0 .774-.813 1.313-1.946 1.313-1.078 0-1.75-.454-1.977-1.164h-1.382c.148 1.398 1.437 2.296 3.312 2.296 1.914 0 3.375-1.04 3.375-2.546 0-1.21-.766-1.9-2.352-2.282l-1.296-.312c-.993-.242-1.46-.602-1.46-1.18 0-.75.78-1.258 1.78-1.258 1.016 0 1.672.446 1.85 1.118h1.33c-.18-1.383-1.407-2.258-3.172-2.258-1.79 0-3.14 1.054-3.14 2.453zm12.032 5.055c1.594 0 2.493-1.157 2.493-3.15 0-2-.9-3.147-2.493-3.147s-2.492 1.15-2.492 3.15c0 1.99.9 3.147 2.492 3.147zm0 1.21c-2.398 0-3.882-1.656-3.882-4.36 0-2.71 1.484-4.358 3.882-4.358 2.4 0 3.883 1.648 3.883 4.36 0 2.702-1.484 4.358-3.883 4.358zm5.993-.148h1.343v-4.984c0-1.477.867-2.375 2.21-2.375 1.345 0 1.986.72 1.986 2.235V385h1.343v-5.453c0-2-1.054-3.117-2.945-3.117-1.29 0-2.11.547-2.53 1.476h-.126v-1.328h-1.28V385zm10.445.078c.562 0 1.015-.46 1.015-1.015 0-.563-.453-1.016-1.015-1.016-.555 0-1.016.453-1.016 1.015 0 .555.46 1.016 1.016 1.016zm4.75 0c.562 0 1.015-.46 1.015-1.015 0-.563-.453-1.016-1.015-1.016-.555 0-1.016.453-1.016 1.015 0 .555.46 1.016 1.016 1.016zm4.75 0c.562 0 1.015-.46 1.015-1.015 0-.563-.453-1.016-1.015-1.016-.555 0-1.016.453-1.016 1.015 0 .555.46 1.016 1.016 1.016z"/>
            </svg>
        </MobileFullSizeContainer>
    );
  }
}

export default CallToolsMobile;



// WEBPACK FOOTER //
// src/assets/CallTools/Mobile/Mobile.js